export default class Banner {
        constructor() {
        this.sections = document.querySelectorAll('.modulo-banner');

        this.modal = document.querySelector('#modal-video'); // modal global
        this.closeBtn = this.modal.querySelector('.btnCloseModal'); // botão de fechar

        this.ready();
    }

    ready() {
        this.sections.forEach(section => {
            const buttonVideo = section.querySelector('.btnActiveVideo');
            if (!buttonVideo) return;
            buttonVideo.addEventListener('click', (e) => {
                e.preventDefault();
                
                const tipo = buttonVideo.dataset.tipo;
                const videoData = buttonVideo.dataset.video; // pode ser URL ou ID
                const content = this.modal.querySelector('.content');

                // limpa conteúdo anterior
                content.innerHTML = '';

                let html = '';

                if (tipo === 'video') {
                    html = `
                        <video autoplay controls loop class="block w-full h-full object-cover">
                            <source src="${videoData}" type="video/mp4">
                            Seu navegador não suporta o elemento de vídeo.
                        </video>
                    `;
                }

                if (tipo === 'youtube') {
                    html = `
                        <iframe 
                            class="aspect-video w-full relative z-0"
                            src="https://www.youtube.com/embed/${videoData}?controls=1&showinfo=0&rel=0&autoplay=0&playlist=${videoData}"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                        ></iframe>
                    `;
                }

                content.innerHTML = html;

                // abre o modal
                this.modal.classList.add('open');

            });
        });

        // evento global de fechar
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => {
                const content = this.modal.querySelector('.content');
                this.modal.classList.remove('open');
                content.innerHTML = ''; // remove vídeo/iframe
            });
        }

    }

}

if (document.querySelector('.modulo-banner')) {
    new Banner();
}
